var _rect, _path, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlanCardLoading = function SvgPlanCardLoading(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 348,
    viewBox: "0 0 217 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 217,
    height: 348,
    rx: 2.72697,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.72697C0 1.2209 1.22091 0 2.72697 0H214.273C215.779 0 217 1.22091 217 2.72697V260H0V2.72697Z",
    fill: "#F3F3F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 276,
    width: 185,
    height: 56,
    rx: 2.72697,
    fill: "#F3F3F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 72,
    width: 139,
    height: 72,
    rx: 2.72697,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 168,
    width: 139,
    height: 40,
    rx: 2.72697,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 24,
    width: 64,
    height: 16,
    rx: 2.72697,
    fill: "#D9D9D9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlanCardLoading);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjE3IiBoZWlnaHQ9IjM0OCIgdmlld0JveD0iMCAwIDIxNyAzNDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHk9IjAuMDAwOTc2NTYyIiB3aWR0aD0iMjE3IiBoZWlnaHQ9IjM0OCIgcng9IjIuNzI2OTciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0wIDIuNzI2OTdDMCAxLjIyMDkgMS4yMjA5MSAwIDIuNzI2OTcgMEgyMTQuMjczQzIxNS43NzkgMCAyMTcgMS4yMjA5MSAyMTcgMi43MjY5N1YyNjBIMFYyLjcyNjk3WiIgZmlsbD0iI0YzRjNGNCIvPgo8cmVjdCB4PSIxNiIgeT0iMjc2IiB3aWR0aD0iMTg1IiBoZWlnaHQ9IjU2IiByeD0iMi43MjY5NyIgZmlsbD0iI0YzRjNGNCIvPgo8cmVjdCB4PSIzOSIgeT0iNzIiIHdpZHRoPSIxMzkiIGhlaWdodD0iNzIiIHJ4PSIyLjcyNjk3IiBmaWxsPSIjRDlEOUQ5Ii8+CjxyZWN0IHg9IjM5IiB5PSIxNjgiIHdpZHRoPSIxMzkiIGhlaWdodD0iNDAiIHJ4PSIyLjcyNjk3IiBmaWxsPSIjRDlEOUQ5Ii8+CjxyZWN0IHg9Ijc3IiB5PSIyNCIgd2lkdGg9IjY0IiBoZWlnaHQ9IjE2IiByeD0iMi43MjY5NyIgZmlsbD0iI0Q5RDlEOSIvPgo8L3N2Zz4K";